module.exports = __webpack_public_path__ + "assets/radio-active.c21effe5.svg";